/* ez-pdp-precut-size — precut PDP Size step. A width chip swaps which height row shows; the height cards are
   plain links to each size's own PDP, so navigation needs no script. */
(function () {
  document.querySelectorAll("[data-ez-size-picker]").forEach(function (root) {
    if (root.__ezSize) return;
    root.__ezSize = true;
    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-ez-size-w]");
      if (!btn) return;
      var w = btn.getAttribute("data-ez-size-w");
      root.querySelectorAll("[data-ez-size-w]").forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("is-selected", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
      });
      root.querySelectorAll("[data-ez-size-hrow]").forEach(function (row) {
        row.hidden = row.getAttribute("data-ez-size-hrow") !== w;
      });
    });
  });
})();
